
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MemberService } from '../../member-details/member-service/MemberService ';
import { TeamService } from '../../team-listing/team.service';

import {
  CalendarA11y,
  CalendarCommonModule,
  CalendarDateFormatter,
  CalendarModule,
  CalendarMonthModule,
  CalendarUtils,
  CalendarWeekModule,
  DateAdapter
} from 'angular-calendar';

import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView
} from 'angular-calendar'; // 👈 EventColor removed
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import {
  differenceInDays,
  differenceInMinutes,
  isSameDay,
  isSameMonth
} from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Events } from '../../models/events';
import { ManageUserService } from '../../services/manage-user-service';
import { SharedServiceService } from '../../services/shared-service.service';
import { EventServiceService } from '../event-service.service';

export interface EventColor {   //  added back locally
  primary: string;
  secondary: string;
}

const colors: Record<string, EventColor> = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};


interface Invitee {
  id: string;
  name?: string;
  email?: string;
}

interface EventWithInvitees extends Events {
  invitees?: Invitee[];
}

@Component({
  selector: 'app-add-event',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ConfirmDialogModule,

    // angular-calendar modules
    CalendarModule,
    CalendarCommonModule,
    CalendarWeekModule,
    CalendarMonthModule,
  ],
  providers: [
    DatePipe,
    SharedServiceService,
    ManageUserService,
    EventServiceService,
    ConfirmationService,
    ToastrService,
    {
      provide: DateAdapter,
      useFactory: adapterFactory,
    },
    {
      provide: CalendarDateFormatter,
      useClass: CalendarDateFormatter,
    },
    {
      provide: CalendarUtils,
      useClass: CalendarUtils,
    },
    {
      provide: CalendarA11y,
      useClass: CalendarA11y,
    },
    provideFlatpickrDefaults({   
      altInput: true,
      altFormat: 'F j, Y H:i',
      dateFormat: 'Y-m-d H:i'
    })
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.css']
})
export class AddEventComponent {
  requiredFieldErrors: {
    eventTitle: boolean;
    eventType: boolean;
    eventStartTime: boolean;
    eventEndTime: boolean;
    timeZone: boolean;
  } = {
    eventTitle: false,
    eventType: false,
    eventStartTime: false,
    eventEndTime: false,
    timeZone: false
  };
  
  loadingEventDetails: boolean = false;
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  visible: boolean = false;
  endTimeError: boolean = false;
  // Flag to show inline error when user selects a past start time
  startTimeInPastError: boolean = false;
  pageTitle = 'Event Creation';
  view: CalendarView = CalendarView.Month;
  moreEvents: any;
  moreEventStyles: any;
  eventColor: any;

  CalendarView = CalendarView;

  viewDate: Date = new Date();
  selectedYear: number = this.viewDate.getFullYear();
  yearOptions: number[] = Array.from({ length: 21 }, (_, i) => this.viewDate.getFullYear() - 10 + i);
  actualDate: any;
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  eventDetails: EventWithInvitees = {
    id: '',
    eventTitle: '',
    eventType: '',
    eventStartTime: '',
    eventEndTime: '',
    callLink: '',
    eventDescription: '',
    eventDate: '',
    name: '',
    email: '',
    status: 'Pending',
    eventCreatedById: '',
    timeZone: '0',
    updateInvitees: false,
    createdFrom: 'Web',
  };
  
   
  
  endDate: Date;
  color: string;
  isEvent: boolean = false;
  isChangedEdit: boolean = false;
  disableUBtn: boolean = false;
  OldInviteesObj = {};
  isEdit: boolean = false;
  isDeleteConfirm: boolean = false;
  deleteConfirmVisible: boolean = false;
  deleteEventId: any;
  deleteCalendarEventId: any;
  isPastDateMessage: boolean = false;
  pastDateMessageVisible: boolean = false;
  teamList: any = [];
  memberList: any = [];
  member: any = '';
  meetings: any[] = [];
  team: any = '';
  eventTypeInfo: any = '';
  isTeam: boolean = false;
  isMember: boolean = false;
  addCalenderEvent: any = [];
  selectedDate: any;
  isUser: boolean = false;
  userDetails: any = [];
  singleEventDetails: any = [];
  isAdd: boolean = false;
  isSearchBoxShow: boolean = false; // Only true when searching
  showPleaseText: boolean = false; // Only true when loading
  isLoadingMembers: boolean = false; // New: loading state for async search
  timeout: any = null;
  searchTerm$ = new Subject<string>();
  searchMembers: any = [];
  memberName: string;
  careuserName: string; // display name for selected user (care user)
  // Edit-only: separate binding so we can move the event date
  editEventDate: string = '';
  // Edit-only: enforce today/future for date picker + manual typing
  editMinDate: string = '';
  editEventDateInPastError: boolean = false;

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event, event.id);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event, event.id);
      },
    },
  ];

  refresh = new Subject<void>();
 
  events: CalendarEvent[] = [];

  activeDayIsOpen: boolean = false;
  role: any;
  isMemberAdvocate: boolean = false;
  userType: string;
  userList: any = [];
  user: any;
  eventList: any = [];
  
  constructor(
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private EventService: EventServiceService,
    private ManageUserService: ManageUserService,
    private memberService: MemberService,
    private teamService: TeamService,
    private sharedService: SharedServiceService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    console.log('AddEventComponent initialized ');
    this.editMinDate = this.getTodayDateString();
    this.initializeComponent();
    // Debounced member search
    this.searchTerm$
      .pipe(
        debounceTime(200),
        switchMap(term => {
          this.isLoadingMembers = true;
          this.showPleaseText = true;
          return this.EventService.searchMembers(term);
        })
      )
      .subscribe({
        next: (response) => {
          this.isLoadingMembers = false;
          this.showPleaseText = false;
          if (response && Array.isArray(response)) {
            this.searchMembers = response;
          } else if (response && Array.isArray(response.memberTeamAssignment)) {
            this.searchMembers = response.memberTeamAssignment;
          } else if (response && Array.isArray(response.result)) {
            this.searchMembers = response.result;
          } else {
            this.searchMembers = [];
          }
          this.isSearchBoxShow = !!this.searchMembers.length;
          // With OnPush change detection we must mark for check when updating from async callbacks
          this.cdr.markForCheck();
        },
        error: () => {
          this.isLoadingMembers = false;
          this.showPleaseText = false;
          this.searchMembers = [];
          this.isSearchBoxShow = false;
          this.cdr.markForCheck();
        }
      });
  }

  // Keep a snapshot of the original event loaded from API so we can detect changes
  private originalEventSnapshot: any = null;
  // Called on input focus
  onMemberInputFocus() {
    if (this.memberName && this.memberName.trim().length > 0 && this.searchMembers.length > 0) {
      this.isSearchBoxShow = true;
    }
  }

  // Called on input blur
  onMemberInputBlur() {
    // Delay hiding to allow click selection
    setTimeout(() => {
      this.isSearchBoxShow = false;
    }, 200);
  }

  // Called on keyup
  onMemberInputKeyup(event: any) {
    const value = event.target.value;
    if (value && value.trim().length > 0) {
      this.isSearchBoxShow = true;
      this.showPleaseText = true;
      this.searchTerm$.next(value);
    } else {
      this.isSearchBoxShow = false;
      this.showPleaseText = false;
      this.searchMembers = [];
      // ensure view updates immediately when input is cleared
      this.cdr.markForCheck();
    }
  }

  // Called when a member is selected
  onMemberSelected(member: any) {
    this.selectedMember(member);
    this.isSearchBoxShow = false;
    this.showPleaseText = false;
    this.searchMembers = [];
  }

  private initializeComponent(): void {
    this.eventDetails.eventType = "0";
    this.userType = '';
    this.user = '';
    this.role = this.sharedService.getloggedUserRole();

    if (this.role == 'Member Advocate') {
      this.isMemberAdvocate = true;
    }

    this.loadEvents();
  }

private loadEvents(): void {
  const user = this.sharedService.getLoggedInUser();
  if (!user || !user.id) {
    console.warn('⚠️ No logged-in user found.');
    return;
  }

  const today = new Date();

  this.EventService.getEvents(user.id, today).subscribe({
    next: (events: any[]) => {
      console.log('Events from API:', events.length);

      // Always store both eventId and calendarEventId on every event
      this.eventList = events.map((evt: any) => {
        // Defensive: always set both eventId and calendarEventId
        if (!evt.eventId && evt.id) evt.eventId = evt.id;
        if (!evt.id && evt.eventId) evt.id = evt.eventId;
        if (!evt.calendarEventId && evt.calendarId) evt.calendarEventId = evt.calendarId;
        return evt;
      });

      if (this.eventList.length === 0) {
        console.warn(' No events returned from API. Check backend.');
      }

      this.transformEventsForCalendar();
    },
    error: (err: any) => {
      console.error('Failed to load events:', err);
      this.toastr.error('Failed to load events');
    }
  });
}



  private transformEventsForCalendar(): void {
    // Always clear events to avoid duplicates and ensure correct mapping
    const newEvents = this.eventList.map((event: any) => {
      try {
        // Defensive: always set both eventId and calendarEventId
        if (!event.eventId && event.id) event.eventId = event.id;
        if (!event.id && event.eventId) event.id = event.eventId;
        if (!event.calendarEventId && event.calendarId) event.calendarEventId = event.calendarId;
        // If still no id, try to use calendarEventId or fallback to a unique string
        if (!event.id && event.calendarEventId) {
          event.id = event.calendarEventId;
        }
        // Defensive: skip events missing required fields
        if (!event.eventTitle || !event.eventDate || !(event.eventStartTime || (event as any).eventTime)) {
          console.warn('Skipping event with missing required fields:', event);
          return null;
        }
        if (!event.id) {
          event.id = `${event.eventTitle}-${event.eventDate}-${event.eventStartTime}`;
        }
        return this.createCalendarEvent(event);
      } catch (error) {
        console.warn('Skipping invalid event:', event, error);
        return null;
      }
    }).filter(Boolean) as CalendarEvent[];

    this.events = newEvents;
    this.refresh.next();
  }
private createCalendarEvent(event: Events): CalendarEvent {
  // Use eventStartTime if present, otherwise fallback to eventTime from API
  const eventTime = event.eventStartTime || (event as any).eventTime;

  // Use eventTitle if present, otherwise fallback to title from API
  const title = event.eventTitle || (event as any).title;

  if (!event.eventDate || !eventTime) {
    throw new Error('Event missing date or time');
  }

  // Split time into hours and minutes
  const [hours, minutes] = eventTime.split(':').map(Number);

  // Create Date object for event start
  const eventDateObj = new Date(event.eventDate);
  eventDateObj.setHours(hours, minutes, 0, 0);

  return {
    id: event.id,
    // keep original fields so we can map back to eventList entries
    title: `${title} at ${eventTime}`,
    start: eventDateObj,
    end: new Date(eventDateObj.getTime() + 60 * 60 * 1000), // 1-hour event
    color: colors['red'],
    resizable: {
      beforeStart: true,
      afterEnd: true,
    },
    calendarEventId: event.calendarEventId || null,
    eventId: event.id || null,
  } as CalendarEvent & { calendarEventId: string | null; eventId: string | null };
}



  private parseDateString(dateStr: string): [number, number, number] {
    const [datePart] = dateStr.split('T');
    const parts = datePart.split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) {
      throw new Error(`Invalid date format: ${dateStr}`);
    }
    return [parts[0], parts[1], parts[2]];
  }

  private parseTimeString(timeStr: string): [number, number] {
    const parts = timeStr.split(':').map(Number);
    if (parts.length < 2 || parts.some(isNaN)) {
      throw new Error(`Invalid time format: ${timeStr}`);
    }
    return [parts[0], parts[1]];
  }

  getEventTypeInfo(eventType: number | string) {
    if (eventType == 1) {
      return "Call With Team";
    } else if (eventType == 2) {
      return "Call With Member";
    } else if (eventType == 3) {
      return "Call Between Member and Doctor";
    } else if (eventType == 4) {
      return "Call Between Member and Nutritionist";
    } else if (eventType == 5) {
      return "Call Between Member and Fitness Instructors";
    } else if (eventType == 6) {
      return "Call Between Member and Psychologist";
    } else if (eventType == 7) {
      return "Call Between Team and Doctor";
    } else if (eventType == 8) {
      return "Call Between Team and Nutritionist";
    } else if (eventType == 9) {
      return "Call Between Team and Fitness Instructors";
    } else if (eventType == 10) {
      return "Call Between Team and Psychologist";
    }
    return "Unknown Event Type";
  }


handleEvent(action: string, event: CalendarEvent, id: any): void {
  console.log('[handleEvent] Clicked event object:', event, 'with id:', id);

  this.isChangedEdit = false;
  this.isEvent = true;
  this.isEdit = true;
  this.isAdd = false;
  this.userList = [];
  this.teamList = [];
  this.modalData = { event, action };

  if (!id) {
    this.toastr.error('Event ID is missing. Cannot load event details.');
    console.error('[handleEvent] Missing event id:', id, 'event:', event);
    return;
  }

  this.loadingEventDetails = true;
  this.visible = true; // Open dialog instantly
  this.cdr.detectChanges();

  console.log('[handleEvent] Calling getEventById with id:', id);
  this.EventService.getEventById(id).subscribe({
    next: (eventFromApi) => {
      console.log('[handleEvent] Response from getEventById:', eventFromApi);
      // Extra: print raw meeting object for debugging
      try {
        console.log('[handleEvent] Raw meeting object received from API:', JSON.stringify(eventFromApi, null, 2));
      } catch (e) {
        console.log('[handleEvent] Raw meeting object (non-serializable):', eventFromApi);
      }

      this.eventDetails = { ...eventFromApi, id };
      // Bind edit date input from event ISO date
      try {
        this.editEventDate = this.eventDetails?.eventDate
          ? String(this.eventDetails.eventDate).split('T')[0]
          : '';
      } catch {
        this.editEventDate = '';
      }
      // Validate the pre-filled date against min date rules (in case backend returns past date)
      this.onEditEventDateChange();
      try {
        this.originalEventSnapshot = JSON.parse(JSON.stringify(this.eventDetails));
      } catch {
        this.originalEventSnapshot = null;
      }

      this.userDetails = this.EventService.getLoggedUser();

      // Defensive date logic (same as old)
      let m: string[] = [];
      let mnth = '';
      if (this.eventDetails.eventDate?.includes('-')) {
        m = this.eventDetails.eventDate.split('T')[0].split('-');
        mnth = m[1];
        if (mnth && mnth[0] === '0') {
          mnth = mnth.replace(mnth[0], '');
        }
      } else {
        const now = new Date();
        mnth = (now.getMonth() + 1).toString();
      }

      this.disableUBtn = differenceInDays(
        new Date(),
        new Date(+m[0], +mnth - 1, +m[2])
      ) > 0;

      if (this.eventDetails.eventCreatedById !== this.userDetails.id) {
        this.eventTypeInfo = this.getEventTypeInfo(this.eventDetails.eventType);
      }

      if (!this.eventDetails.timeZone) {
        this.eventDetails.timeZone = '0';
      }

      this.OldInviteesObj = {
        userId: this.eventDetails.eventAudienceUserId,
        memberId: this.eventDetails.eventAudienceMemberId,
        teamId: this.eventDetails.eventAudienceTeamId
      };

      this.loadEventDetailsBasedOnType();

      console.log('[handleEvent] Opening modal with eventDetails:', this.eventDetails);
      this.loadingEventDetails = false;
      this.cdr.markForCheck();
    },
    error: (err) => {
      console.error('[handleEvent] getEventById failed:', err);
      this.toastr.error('Failed to load event details from backend.');
      this.loadingEventDetails = false;
    }
  });
}

private getTodayDateString(): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

onEditEventDateChange() {
  // When user changes date in Edit dialog, update eventDetails.eventDate so update payload includes it
  const d = (this.editEventDate || '').trim();
  if (d) {
    // Validate: date must be today or future
    const today = this.getTodayDateString();
    const isPast = d < today; // safe because YYYY-MM-DD lexicographical order matches date order
    this.editEventDateInPastError = isPast;
    if (isPast) {
      this.toastr.error("Past date can't be selected");
      this.disableUBtn = true; // disable Update button
      this.cdr.markForCheck();
      return;
    }
    this.editEventDateInPastError = false;

    // Keep as ISO-like string so backend can parse consistently, while time remains separate fields
    this.eventDetails.eventDate = `${d}T00:00:00.000Z`;
    // Allow updates when moved to today/future
    this.disableUBtn = false;
  }
  this.cdr.markForCheck();
}


private loadEventDetailsBasedOnType(): void {
  const eventType = Number(this.eventDetails.eventType);
  console.log('[loadEventDetailsBasedOnType] Event type:', eventType);
  console.log('[loadEventDetailsBasedOnType] Event audience memberId:', this.eventDetails.eventAudienceMemberId);

  if (eventType === 1 || (eventType > 6 && eventType < 11)) {
    this.teamService.getAllCohort(1, '').subscribe((response: any) => {
      this.teamList = response.result;
    });
    this.isTeam = true;

  } else if (eventType > 1 && eventType < 7) {
    this.memberName = this.eventDetails.name;
    this.isMember = true;

    // Null validation before making API calls
    if (this.eventDetails.eventAudienceMemberId) {
      this.memberService.getMemberById(this.eventDetails.eventAudienceMemberId)
        .subscribe({
          next: (response: any) => {
            this.member = response;
            try {
              const full = (response.fullName ?? `${response.firstName ?? ''} ${response.lastName ?? ''}`).trim();
              this.memberName = full || (this.eventDetails.name || '');
            } catch (e) {
              // fallback to existing eventDetails.name if member response shape unexpected
              this.memberName = this.eventDetails.name || '';
            }
            this.cdr.markForCheck();
          },
          error: (error) => {
            console.error('[loadEventDetailsBasedOnType] Error fetching member details:', error);
            this.member = null;
          }
        });

      this.meetings = [];
      this.memberService.GetMeetings(this.eventDetails.eventAudienceMemberId)
        .subscribe({
          next: (response: any) => {
            // Normalize different backend response shapes into an array
            this.meetings = Array.isArray(response)
              ? response
              : (Array.isArray(response?.result) ? response.result : []);
          },
          error: (error) => {
            console.error('[loadEventDetailsBasedOnType] Error fetching meetings:', error);
            this.meetings = [];
          }
        });
    } else {
      console.warn('[loadEventDetailsBasedOnType] eventAudienceMemberId is null or undefined, skipping API calls');
      this.member = null;
      this.meetings = [];
    }
  }

  this.setUserTypeBasedOnEvent(eventType);
}
private setUserTypeBasedOnEvent(eventType: number): void {
  if (eventType === 3 || eventType === 7) {
    this.userType = 'Doctor';
  } else if (eventType === 4 || eventType === 8) {
    this.userType = 'Nutritionist';
  } else if (eventType === 5 || eventType === 9) {
    this.userType = 'Fitness Instructor';
  } else if (eventType === 6 || eventType === 10) {
    this.userType = 'Psychologists';
  }

  if (eventType > 2 && eventType < 11) {
    this.ManageUserService.getAllUsers(this.userType, '', 100).subscribe(response => {
      this.userList = response;
      // If the event already has a selected user, populate a display name for it.
      if (this.eventDetails && this.eventDetails.eventAudienceUserId) {
        try {
          const uid = String(this.eventDetails.eventAudienceUserId);
          const found = (this.userList || []).find((u: any) => String(u.id) === uid);
          if (found) {
            this.careuserName = `${found.firstName ?? ''} ${found.lastName ?? ''}`.trim();
          }
        } catch (e) {
          // ignore
        }
      }
    });
    this.isUser = true;
  }
}

  closeDialog(id: any) {
    this.isEvent = false;
    if (id == 1) {
      this.isAdd = false;
    } else {
      this.isEdit = false;
    }
  }

  dialogCLose($event: any) {
    this.isEvent = false;
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    this.resetEventDetails();
    this.memberName = '';
    this.isUser = false;
    this.isMember = false;
    this.member = '';
    this.isTeam = false;
    this.team = '';

    const selectDate = date.getDate();
    const currentDate = new Date();
    const selectcurrentMonth = currentDate.getDate();

    if (date >= currentDate || selectcurrentMonth == selectDate) {
      if (isSameMonth(date, this.viewDate)) {
        if (
          (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
          events.length === 0
        ) {
          this.visible = true;
          this.isEdit = false;
          this.isAdd = true;
        } else {
          if (this.isEvent == false) {
            this.visible = true;
            this.isEdit = false;
            this.isAdd = true;
          }
        }
        const _date = new Date(date);

        this.viewDate = date;
        this.actualDate = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        var twoDigitMonth = ((date.getMonth() + 1) >= 10) ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
        var twoDigitDate = ((date.getDate()) >= 10) ? (date.getDate()) : '0' + (date.getDate());
        this.selectedDate = date.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate;
      }
    } else {
      // Handle past date - show message
      this.showPastDateMessage();
    }
    this.isEvent = false;
  }

  private resetEventDetails(): void {
    this.eventDetails = {
      id: '',
      eventTitle: '',
      eventType: '',
      eventStartTime: '',
      eventEndTime: '',
      callLink: '',
      eventDescription: '',
      eventDate: '',
      name: '',
      email: '',
      status: 'Pending',
      eventCreatedById: '',
      timeZone: '0',
      updateInvitees: false,
      createdFrom: 'Web',
    };
  }

  timeClicked() {
    this.visible = true;
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event , event.id);
  }

checkRequiredFields(): boolean {
  this.requiredFieldErrors = {
    eventTitle: false,
    eventType: false,
    eventStartTime: false,
    eventEndTime: false,
    timeZone: false
  };
  let valid = true;
  if (!this.eventDetails.eventTitle || this.eventDetails.eventTitle.trim() === '') {
    this.requiredFieldErrors.eventTitle = true;
    valid = false;
  }
  if (!this.eventDetails.eventType || this.eventDetails.eventType === '0') {
    this.requiredFieldErrors.eventType = true;
    valid = false;
  }
  if (!this.eventDetails.eventStartTime || this.eventDetails.eventStartTime === 'NaN:NaN') {
    this.requiredFieldErrors.eventStartTime = true;
    valid = false;
  }
  if (!this.eventDetails.eventEndTime || this.eventDetails.eventEndTime === 'NaN:NaN') {
    this.requiredFieldErrors.eventEndTime = true;
    valid = false;
  }
  if (!this.eventDetails.timeZone || this.eventDetails.timeZone === '0') {
    this.requiredFieldErrors.timeZone = true;
    valid = false;
  }
  return valid;
}

  checkDataValidation() {
if (!this.eventDetails.eventTitle || this.eventDetails.eventStartTime === '' ||
    this.eventDetails.eventStartTime === 'NaN:NaN' || this.eventDetails.eventEndTime === 'NaN:NaN' ||
    !this.eventDetails.eventType || this.eventDetails.eventType === '0' ||
    !this.eventDetails.timeZone || this.eventDetails.timeZone === '0') {
  this.toastr.error("Please select required values");
  return false;
}

if (this.eventDetails.eventType === '1' && 
   (!this.eventDetails.eventAudienceTeamId || this.eventDetails.eventAudienceTeamId === '')) {
  this.toastr.error("Team not found");
  return false;
}

if (this.eventDetails.eventType === '2' && 
   (!this.eventDetails.eventAudienceMemberId || !this.memberName || !this.eventDetails.name)) {
  this.toastr.error("Member not found");
  return false;
}
const eventTypeNum = Number(this.eventDetails.eventType);

if (eventTypeNum > 2 && eventTypeNum < 7 &&
   (!this.eventDetails.eventAudienceMemberId || !this.memberName || !this.eventDetails.name || !this.eventDetails.eventAudienceUserId)) {
  this.toastr.error("Member/User not found");
  return false;
}

if (eventTypeNum > 6 && eventTypeNum < 11 &&
   (!this.eventDetails.eventAudienceTeamId || !this.eventDetails.eventAudienceUserId)) {
  this.toastr.error("Team/User not found");
  return false;
}

    if (this.eventDetails.eventStartTime != '' && this.eventDetails.eventEndTime != '') {
      let st = new Date(this.eventDetails.eventDate.split("T")[0] + " " + this.eventDetails.eventStartTime.padStart(5, '0') + ":00");
      let et = new Date(this.eventDetails.eventDate.split("T")[0] + " " + this.eventDetails.eventEndTime.padStart(5, '0') + ":00");
      if (et <= st) {
        this.toastr.error('End time should be greater than start time.');
        return false;
      }
    }
    return true;
  }

  getTimeFormat(selectedTime: any) {
    let currentDate = new Date(selectedTime);
    let time: any;
    if (currentDate.getMinutes() < 1) {
      time = currentDate.getHours() + ':00';
    } else if (currentDate.getMinutes() < 10) {
      time = currentDate.getHours() + ':0' + currentDate.getMinutes();
    }
    else {
      time = currentDate.getHours() + ':' + currentDate.getMinutes();
    }
    return time;
  }

setNotReqValuesToNull() {
  if (this.eventDetails.eventType === "1") {
    this.eventDetails.eventAudienceUserId = null;
    this.eventDetails.eventAudienceMemberId = null;
    this.eventDetails.email = "";
  }
  if (this.eventDetails.eventType === "2") {
    this.eventDetails.eventAudienceTeamId = null;
    this.eventDetails.eventAudienceUserId = null;
  }
  if (+this.eventDetails.eventType > 2 && +this.eventDetails.eventType < 7) {
    this.eventDetails.eventAudienceTeamId = null;
    this.eventDetails.name = "Group Call";
  }
  if (+this.eventDetails.eventType > 6 && +this.eventDetails.eventType < 11) {
    this.eventDetails.eventAudienceMemberId = null;
    this.eventDetails.name = "Group Call";
    this.eventDetails.email = "";
  }
}

  performDateValidation() {
    let cur;
    let viewD = new Date(this.viewDate);
    if (typeof this.eventDetails.eventStartTime !== "string") {
      cur = new Date(this.eventDetails.eventStartTime);
      viewD.setHours(cur.getHours());
      viewD.setMinutes(cur.getMinutes());
    } else {
      cur = this.eventDetails.eventStartTime.split(':');
      viewD.setHours(+cur[0]);
      viewD.setMinutes(+cur[1]);
    }
    let eventsL = [];
    eventsL = this.eventList.filter((obj: any) => { return obj.timeZone == this.eventDetails.timeZone });
    let evts: CalendarEvent[] = [];
    eventsL.forEach((evt: any) => {
      let e = this.events.filter((obj: any) => { return obj.id == evt.id })[0];
      if (e) {
        evts.push(e);
      }
    });
    for (const evt of evts) {
      if (differenceInMinutes(viewD, evt.start) == 0 && this.eventDetails.id != evt.id) {
        this.toastr.error("Event Already Scheduled at this time. Please select another time.");
        return false;
      }
    };

    var d = new Date();
    d.setSeconds(0);
    let convCurrentDate = new Date(d.toLocaleString('en-US', { timeZone: this.eventDetails.timeZone }));
    if (differenceInMinutes(viewD, convCurrentDate) < 0) {
      // Set inline flag so UI can display the error under the time input
      this.startTimeInPastError = true;
      // Also show toast for backwards compatibility
      this.toastr.error("Time Already Passed. Please select future time.");
      return false;
    }
    // Clear the inline error when validation passes
    this.startTimeInPastError = false;
    return true;
  }

addNewEvent(): void {
  this.endTimeError = false;
  console.log('[AddEvent] addNewEvent() called');

  // ──────────────── 1. Basic Field & Date Validation ────────────────
  if (!this.checkRequiredFields()) {
    console.warn('[AddEvent] Validation failed: checkRequiredFields()');
    return;
  }
  // Inline end time validation
  if (this.eventDetails.eventStartTime && this.eventDetails.eventEndTime) {
    const dateStr = this.eventDetails.eventDate ? this.eventDetails.eventDate.split('T')[0] : (this.selectedDate || '');
    if (dateStr) {
      let st = new Date(dateStr + 'T' + this.eventDetails.eventStartTime.padStart(5, '0'));
      let et = new Date(dateStr + 'T' + this.eventDetails.eventEndTime.padStart(5, '0'));
      if (et <= st) {
        this.endTimeError = true;
        return;
      }
    }
  }
  if (!this.performDateValidation()) {
    console.warn('[AddEvent] Validation failed: performDateValidation()');
    return;
  }

  // ──────────────── 2. Logged-in User Validation ────────────────
  this.userDetails = this.EventService.getLoggedUser();
  if (!this.userDetails?.id) {
    this.toastr.error('User information not found');
    console.warn('[AddEvent] No logged-in user found');
    return;
  }

  // 🔹 FIX: Always stringify & trim logged-in user id
  this.eventDetails.eventCreatedById = String(this.userDetails.id).trim();
  console.log('[AddEvent] eventCreatedById set to:', this.eventDetails.eventCreatedById);

  this.eventDetails.createdByName =
    this.userDetails.name || this.userDetails.email || 'System';

  // ──────────────── 3. Event Type & Audience ────────────────
  const eventTypeNum = Number(this.eventDetails.eventType) || 0;

  if (eventTypeNum === 1 || (eventTypeNum > 6 && eventTypeNum < 11)) {
    // Team Event
    if (!this.team) {
      this.toastr.error('Please select a team');
      console.warn('[AddEvent] Team not selected');
      return;
    }

    this.eventDetails.eventAudienceTeamId = this.team;
    const selectedTeam = this.teamList.find((t: any) => t.teamId === this.team);
    if (!selectedTeam) {
      this.toastr.error('Selected team not found');
      console.warn('[AddEvent] Selected team not found in teamList');
      return;
    }

    this.eventDetails.name = selectedTeam.teamName;
    this.eventDetails.email = this.userDetails.email ?? '';

  } else if (eventTypeNum > 1 && eventTypeNum < 7) {
    // Member Event
    console.log('[AddEvent] eventCreatedById being sent:', this.eventDetails.eventCreatedById);
    if (!this.member || !this.member.memberId) {
      this.toastr.error('Please select a member');
      console.warn('[AddEvent] Member not selected or invalid', this.member);
      return;
    }

    this.eventDetails.eventAudienceMemberId = String(this.member.memberId).trim(); // 🔹 FIX: ensure clean string
    this.eventDetails.name = `${this.member.firstName ?? ''} ${this.member.lastName ?? ''}`.trim();
    this.eventDetails.email = this.member.email ?? this.userDetails.email ?? '';

  } else {
    this.toastr.error('Invalid event type selected');
    console.warn('[AddEvent] Invalid event type', eventTypeNum);
    return;
  }

  // ──────────────── 4. Date & Time Normalization ────────────────
  const d = this.selectedDate ? new Date(this.selectedDate) : new Date();
  this.eventDetails.eventDate = d.toISOString();

  const normalizeTime = (time: any): string =>
    typeof time === 'string' ? time : (this.getTimeFormat(time) || '');

  this.eventDetails.eventStartTime = normalizeTime(this.eventDetails.eventStartTime);
  this.eventDetails.eventEndTime = normalizeTime(this.eventDetails.eventEndTime);

  const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

  if (!timeRegex.test(this.eventDetails.eventStartTime)) {
    this.toastr.error('Invalid start time format. Use HH:MM');
    console.warn('[AddEvent] Invalid start time', this.eventDetails.eventStartTime);
    return;
  }

  if (this.eventDetails.eventEndTime && !timeRegex.test(this.eventDetails.eventEndTime)) {
    this.toastr.error('Invalid end time format. Use HH:MM');
    console.warn('[AddEvent] Invalid end time', this.eventDetails.eventEndTime);
    return;
  }

  // ──────────────── 5. Duplicate Meeting Check (Member only) ────────────────
  if (eventTypeNum > 1 && eventTypeNum < 7) {
    // Defensive: meetings API can return non-array shapes; always treat as array here
    const meetingsArr = Array.isArray(this.meetings)
      ? this.meetings
      : (Array.isArray((this.meetings as any)?.result) ? (this.meetings as any).result : []);
    const isDuplicate = meetingsArr.some((m: any) =>
      (m.eventAudienceMemberId === this.eventDetails.eventAudienceMemberId ||
       m.eventAudienceTeamId === this.member?.teamId) &&
      m.eventStartTime === this.eventDetails.eventStartTime &&
      m.eventDate?.split('T')[0] === this.eventDetails.eventDate?.split('T')[0] &&
      m.timeZone === this.eventDetails.timeZone
    );

    if (isDuplicate) {
      this.toastr.error('Member meeting already scheduled at this time');
      console.warn('[AddEvent] Duplicate meeting detected');
      return;
    }
  }

  // ──────────────── 6. Extra Data Validation ────────────────
  if (!this.checkDataValidation()) {
    console.warn('[AddEvent] checkDataValidation() failed');
    return;
  }

  // ──────────────── 7. Final Cleanup ────────────────
  this.setNotReqValuesToNull();
  if (!this.eventDetails.email) {
    this.eventDetails.email = this.userDetails.email || 'noreply@completumhealth.com';
  }
  this.eventDetails.status = 'Active';

  // ──────────────── 8. Build Payload ────────────────
  const payload: any = { ...this.eventDetails };
  delete payload.id;

  ['eventAudienceMemberId', 'eventAudienceUserId', 'eventAudienceTeamId']
    .forEach((k) => { if (!payload[k]) delete payload[k]; });

  payload.createdFrom = payload.createdFrom || 'WebApp';
  payload.timeZone = payload.timeZone || 'UTC';
  payload.callLink = payload.callLink || '';

  console.log('[AddEvent] Final event payload ready:', payload);

  // Log Google Calendar related fields
  console.log('[GoogleCalendar] Create event settings:', {
    hasEmail: !!payload.email,
    hasTimeZone: !!payload.timeZone,
    email: payload.email || 'Not set',
    timeZone: payload.timeZone || 'Not set',
    eventType: payload.eventType
  });

  // ──────────────── 9. Submit to API ────────────────
  this.EventService.addEvent(payload).subscribe({
    next: (res: any) => {
      console.log('[AddEvent] Event created:', res);

      // Log Google Calendar creation status
      console.log('[GoogleCalendar] Creation response:', {
        success: !!res,
        eventId: res?.id || 'Not returned',
        calendarEventId: res?.calendarEventId || 'Not returned',
        googleCalendarId: res?.googleCalendarId || 'Not returned',
        googleEventId: res?.googleEventId || 'Not returned',
        googleCalendarError: res?.googleCalendarError || 'None'
      });

      if (res?.googleCalendarError) {
        console.warn('[GoogleCalendar] Google Calendar creation failed:', res.googleCalendarError);
        this.toastr.warning(`Event saved in database but Google Calendar creation failed: ${res.googleCalendarError}`);
      } else if (!res?.googleCalendarId && !res?.googleEventId) {
        console.warn('[GoogleCalendar] Creation successful but no Google Calendar IDs returned');
        this.toastr.warning('Event created but Google Calendar sync status unknown');
      } else {
        console.log('[GoogleCalendar] Creation successful with Google Calendar sync');
      }

      // Determine the correct event id from the response before verifying.
      // The backend may return:
      //  - { id, ... }
      //  - { eventId, ... }
      //  - { result: { id | eventId, ... } }
      const verificationId =
        (res as any)?.id ||
        (res as any)?.eventId ||
        (res as any)?.result?.id ||
        (res as any)?.result?.eventId;

      if (verificationId && verificationId !== 'undefined') {
        // Verify the event was properly saved with all IDs
        this.EventService.getEventById(verificationId).subscribe(
          verifiedEvent => {
            console.log('[GoogleCalendar] Post-creation verification:', {
              eventId: verifiedEvent?.id || 'Missing',
              calendarEventId: verifiedEvent?.calendarEventId || 'Missing',
              googleCalendarId: verifiedEvent?.googleCalendarId || 'Missing',
              googleEventId: verifiedEvent?.googleEventId || 'Missing',
              hasAllIds: !!(verifiedEvent?.id && verifiedEvent?.calendarEventId && 
                (verifiedEvent?.googleCalendarId || verifiedEvent?.googleEventId))
            });

            if (!verifiedEvent?.calendarEventId) {
              console.warn('[GoogleCalendar] Warning: Created event missing calendarEventId - updates will not sync with Google Calendar');
              this.toastr.warning('Event created but missing Google Calendar ID - updates may not sync properly');
            }
          },
          error => {
            console.error('[GoogleCalendar] Post-creation verification failed:', error);
          }
        );
      } else {
        console.warn('[AddEvent] Skipping post-creation verification: response does not contain a valid event id', res);
      }
      // Save the returned event directly from the create response
      let eventObj = res;
      if (res && typeof res === 'object' && 'result' in res && res.result) {
        eventObj = res.result;
      }

      // Remove any old instance with same id
      const newId = eventObj?.id || eventObj?.eventId;
      if (newId) {
        this.eventList = this.eventList.filter((e: any) => e.id !== newId);
        
        // Store the calendar event ID if available
        if (eventObj.calendarEventId) {
          this.eventDetails.calendarEventId = eventObj.calendarEventId;
          this.deleteCalendarEventId = eventObj.calendarEventId;
        }
        // Only push if required fields are present
        if (eventObj && eventObj.eventTitle && eventObj.eventDate && (eventObj.eventStartTime || (eventObj as any).eventTime)) {
          this.eventList.push(eventObj);
          this.eventDetails = eventObj;
        } else {
          console.warn('[AddEvent] Skipping event with missing required fields:', eventObj);
        }
        this.toastr.success('Event added successfully');
        this.visible = false;
        try {
          this.transformEventsForCalendar();
          this.refresh.next();
        } catch (e) {
          window.location.reload();
        }
      } else {
        // fallback: only push if required fields are present
        if (eventObj && eventObj.eventTitle && eventObj.eventDate && (eventObj.eventStartTime || (eventObj as any).eventTime)) {
          this.eventList.push(eventObj);
        } else {
          console.warn('[AddEvent] Skipping event with missing required fields after create:', eventObj);
        }
        this.toastr.success('Event added successfully');
        this.visible = false;
        try {
          this.transformEventsForCalendar();
          this.refresh.next();
        } catch (e) {
           window.location.reload();
        }
      }
    },
    error: (err) => {
      console.error('[AddEvent] Event creation failed', err);

      if (err.error?.errors) {
        for (const key of Object.keys(err.error.errors)) {
          const messages = err.error.errors[key];
          (Array.isArray(messages) ? messages : [messages])
            .forEach((msg: string) => this.toastr.error(`${key}: ${msg}`));
        }
      } else if (err.error?.message) {
        this.toastr.error(err.error.message);
      } else {
        this.toastr.error('Failed to add event');
      }
    },
  });
}



  addEvent(): void {
    this.visible = true;
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
    this.selectedYear = this.viewDate.getFullYear();
    this.cdr.markForCheck();
  }

  onYearChange(year: number): void {
    const newDate = new Date(this.viewDate);
    newDate.setFullYear(+year);
    this.viewDate = newDate;
    this.selectedYear = +year;
    this.closeOpenMonthViewDay();
  }

  handleMoreEvent(e: any, events: []) {
    this.moreEvents = events;

    this.moreEventStyles.top = `${e.srcElement.offsetTop}px`;
    this.moreEventStyles.left = `${e.srcElement.offsetLeft}px`;
    this.moreEventStyles = { ...this.moreEventStyles };
  }

  changeEventTypeAdd(data: any) {
    this.resetEventTypeFields();
    if (data.target.value == 1 || (data.target.value > 6 && data.target.value < 11)) {
      this.loadTeamsForEventType(data);
    } else if (data.target.value > 1 && data.target.value < 7) {
      this.setMemberEventType(data);
    } else {
      this.isTeam = false;
      this.isMember = false;
    }

    this.setUserTypeForEvent(data);
  }

  private resetEventTypeFields(): void {
    this.eventDetails.eventAudienceMemberId = "",
    this.eventDetails.eventAudienceUserId = "",
    this.eventDetails.eventAudienceTeamId = "",
    this.memberName = "";
    this.eventDetails.timeZone = '0';
    this.userList = [];
    this.teamList = [];
  }

  private loadTeamsForEventType(data: any): void {
    this.teamService.getAllCohort(1, '').subscribe((response: any) => {
      this.teamList = response.result;
      this.isTeam = true;
      this.isMember = false;

      if (data.target.value == 1) {
        this.isUser = false;
      } else {
        this.isUser = true;
      }
    });
  }

  private setMemberEventType(data: any): void {
    this.isTeam = false;
    this.isMember = true;
    if (data.target.value == 2) {
      this.isUser = false;
      } else {
      this.isUser = true;
    }
  }

  private setUserTypeForEvent(data: any): void {
    if (data.target.value == 3 || data.target.value == 7) {
      this.userType = 'Doctor';
    } else if (data.target.value == 4 || data.target.value == 8) {
      this.userType = 'Nutritionist';
    } else if (data.target.value == 5 || data.target.value == 9) {
      this.userType = 'Fitness Instructor';
    }
    else if (data.target.value == 6 || data.target.value == 10) {
      this.userType = 'Psychologists';
    }
    if (this.userType != '') {
      this.ManageUserService.getAllUsers(this.userType, '', 100).subscribe(response => {
        this.userList = response;
      });
    }
  }

  changeEventType(data: any) {
    this.resetEventTypeFields();
    if (data.target.value == 1 || (data.target.value > 6 && data.target.value < 11)) {
      this.loadTeamsForEventType(data);
    }
    else if (data.target.value > 1 && data.target.value < 7) {
      this.isTeam = false;
      this.isMember = true;

      if (data.target.value == 2) {
        this.isUser = false;
      } else {
        this.isUser = true;
      }
    }
    else {
      this.isTeam = false;
      this.isMember = false;
    }
    this.setUserTypeForEvent(data);
  }

 updateEvent() {
  // Check if we have an event ID before proceeding
  if (!this.eventDetails.id) {
    this.toastr.error('Event ID is missing. Cannot update event.');
    return;
  }

  // Forcefully clear lingering search UI and loading text on update
  this.isSearchBoxShow = false;
  this.searchMembers = [];
  this.showPleaseText = false;
  setTimeout(() => {
    const pleaseWait = document.querySelector('.searchBox span');
    if (pleaseWait && pleaseWait.textContent?.includes('Please wait')) {
      pleaseWait.remove();
    }
  }, 0);

  if (!this.checkRequiredFields()) return;
  if (!this.performDateValidation()) return;

  const eventTypeNum = +this.eventDetails.eventType; // ensure numeric comparison

  // Team events
  if (eventTypeNum === 1 || (eventTypeNum > 6 && eventTypeNum < 11)) {
    this.eventDetails.eventAudienceMemberId = null;
    this.eventDetails.name = '';
    this.eventDetails.email = '';
    if (eventTypeNum === 1) {
      this.eventDetails.eventAudienceUserId = null;
    }
  }
  // Member events
  else if (eventTypeNum > 1 && eventTypeNum < 7) {
    this.eventDetails.eventAudienceTeamId = null;
    if (eventTypeNum === 2) {
      this.eventDetails.eventAudienceUserId = null;
    }
    if (this.isChangedEdit && this.member) {
      const memberId = (this.member.memberId ?? this.member.id ?? '').toString();
      this.eventDetails.eventAudienceMemberId = memberId;
      this.eventDetails.name = `${this.member.firstName ?? ''} ${this.member.lastName ?? ''}`.trim();
      this.eventDetails.email = this.member.email;
    }
  }

  // Normalize start time
  if (typeof this.eventDetails.eventStartTime !== "string") {
    const currentDate = new Date(this.eventDetails.eventStartTime);
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    this.eventDetails.eventStartTime =
      minutes < 10 ? `${hours}:0${minutes}` : `${hours}:${minutes}`;
  }

  // Normalize end time
  if (typeof this.eventDetails.eventEndTime !== "string") {
    this.eventDetails.eventEndTime = this.getTimeFormat(this.eventDetails.eventEndTime);
  }

  const newInviteesObj = {
    userId: this.eventDetails.eventAudienceUserId,
    memberId: this.eventDetails.eventAudienceMemberId,
    teamId: this.eventDetails.eventAudienceTeamId
  };

  if (JSON.stringify(this.OldInviteesObj) !== JSON.stringify(newInviteesObj)) {
    this.eventDetails.updateInvitees = true;
  }

  this.isChangedEdit = false;


  // Ensure we have a valid ID for the event
  let id = this.eventDetails.id;
  if (!id || id === '' || id === undefined) {
    this.toastr.error('Event ID is missing. Cannot update event.');
    return;
  }
  
  const found = this.events.findIndex(x => x.id === id);

  if (!this.checkDataValidation()) return;

  this.setNotReqValuesToNull();
  this.eventDetails.createdFrom = 'Web';

  // Prevent duplicate meetings
  if (eventTypeNum > 1 && eventTypeNum < 7) {
    // Guard: ensure this.meetings is always an array
    if (!Array.isArray(this.meetings)) {
      this.meetings = [];
    }
    this.meetings = this.meetings.filter((obj: any) => obj.id !== id);
    for (let meeting of this.meetings) {
      if (
        (meeting.eventAudienceMemberId === this.eventDetails.eventAudienceMemberId ||
          meeting.eventAudienceTeamId === this.member?.teamId) &&
        meeting.eventStartTime === this.eventDetails.eventStartTime &&
        meeting.eventDate.split('T')[0] === this.eventDetails.eventDate.split('T')[0] &&
        meeting.timeZone === this.eventDetails.timeZone
      ) {
        this.toastr.error("Members Meeting already scheduled at this time");
        return;
      }
    }
  }

  // Update via service
  console.log('[GoogleCalendar] Pre-update event state:', {
    eventId: id,
    calendarEventId: this.eventDetails.calendarEventId || 'Missing',
    googleCalendarId: this.eventDetails.googleCalendarId || 'Missing',
    googleEventId: this.eventDetails.googleEventId || 'Missing',
    hasRequiredIds: !!(this.eventDetails.calendarEventId && 
      (this.eventDetails.googleCalendarId || this.eventDetails.googleEventId))
  });

  if (!this.eventDetails.calendarEventId) {
    console.warn('[GoogleCalendar] Warning: Attempting update without calendarEventId - Google Calendar will not be updated');
  }

  console.log('[UpdateEvent] Full update payload:', {
    eventId: id,
    eventType: this.eventDetails.eventType,
    startTime: this.eventDetails.eventStartTime,
    endTime: this.eventDetails.eventEndTime,
    updateInvitees: this.eventDetails.updateInvitees,
    calendarIds: {
      calendarEventId: this.eventDetails.calendarEventId,
      googleCalendarId: this.eventDetails.googleCalendarId,
      googleEventId: this.eventDetails.googleEventId
    },
    audienceDetails: {
      userId: this.eventDetails.eventAudienceUserId,
      memberId: this.eventDetails.eventAudienceMemberId,
      teamId: this.eventDetails.eventAudienceTeamId
    }
  });

  this.EventService.updateEvent(this.eventDetails, id).subscribe(
    response => {
    this.events[found].title =
      this.eventDetails.eventTitle + ' at ' + this.eventDetails.eventStartTime;

    const start = this.events[found].start;
    start.setHours(+this.eventDetails.eventStartTime.split(':')[0]);
    start.setMinutes(+this.eventDetails.eventStartTime.split(':')[1]);
    this.events[found].start = start;

    this.eventList[found] = this.eventDetails;
    this.refresh.next(); // <-- trigger calendar UI update
    this.visible = false;
    console.log('[GoogleCalendar] Update result:', {
      dbSuccess: !!response,
      googleCalendarId: (response as any)?.googleCalendarId || 'Not returned',
      googleEventId: (response as any)?.googleEventId || 'Not returned',
      googleError: (response as any)?.googleCalendarError || 'None'
    });
    
    if ((response as any)?.googleCalendarError) {
      this.toastr.warning(`Database updated but Google Calendar sync failed: ${(response as any).googleCalendarError}`);
    } else {
      this.toastr.success('Event updated successfully');
    }
    // Refresh the page to show the updated event
    window.location.reload();
  });
}



  confirmDelete(id: any, calId: any) {
    // Store the IDs for later use
    this.deleteEventId = id;
    this.deleteCalendarEventId = calId;
    
    // Close edit dialog if it's open
    this.visible = false;
    
    // Show custom confirmation dialog
    this.isDeleteConfirm = true;
    this.deleteConfirmVisible = true;
    
    // Prevent body scroll
    document.body.classList.add('modal-open');
  }

  confirmDeleteAction() {
    // Fallback: use eventId or calendarEventId if id is missing (cast to any for TS safety)
    let idParam = this.deleteEventId;
    if (!idParam || idParam === 'undefined' || idParam === undefined) {
      const detailsAny = this.eventDetails as any;
      idParam = (detailsAny.eventId || detailsAny.calendarEventId || '').toString();
      if (!idParam || idParam === 'undefined' || idParam === undefined) {
        this.toastr.error('Event ID is missing. Cannot delete event.');
        console.error('Event ID is missing in confirmDelete:', this.deleteEventId, this.deleteCalendarEventId);
        this.cancelDelete();
        return;
      }
    }
    if (this.deleteCalendarEventId) {
      // preserve existing API behaviour which expects id_calendarEventId when calendar id present
      idParam = idParam + "_" + this.deleteCalendarEventId;
    }
    const eventDetails = this.eventDetails as EventWithInvitees;
    console.log('[confirmDeleteAction] Event details before deletion:', {
      eventId: this.deleteEventId,
      event: eventDetails,
      invitees: eventDetails?.invitees,
      eventType: eventDetails?.eventType
    });

    console.log('[confirmDeleteAction] Deleting event with idParam:', idParam, 'deleteCalendarEventId:', this.deleteCalendarEventId);

    this.EventService.deleteEvent(idParam).subscribe((response) => {
        console.log('[deleteEvent] Delete response:', response);
        console.log('[deleteEvent] Affected invitees who should receive notification:', eventDetails?.invitees);
        
        const found = this.events.findIndex(x => x.id == this.deleteEventId);
        this.events = this.events.filter((iEvent) => iEvent.id !== this.deleteEventId);
        this.eventList = this.eventList.filter((iEvt: any) => iEvt.id !== this.deleteEventId);
        this.visible = false;
        this.deleteConfirmVisible = false;
        this.isDeleteConfirm = false;
      
      // Restore body scroll
      document.body.classList.remove('modal-open');
      
      this.toastr.success("Event deleted successfully.");
      // Refresh the page to show the updated event list
      window.location.reload();
    });
  }

  cancelDelete() {
    this.deleteConfirmVisible = false;
    this.isDeleteConfirm = false;
    this.deleteEventId = null;
    this.deleteCalendarEventId = null;
    
    // Restore body scroll
    document.body.classList.remove('modal-open');
  }

  // Past date message methods
  private showPastDateMessage(): void {
    this.isPastDateMessage = true;
    this.pastDateMessageVisible = true;
    document.body.classList.add('modal-open');
  }

  closePastDateMessage(): void {
    this.pastDateMessageVisible = false;
    this.isPastDateMessage = false;
    document.body.classList.remove('modal-open');
  }



// Debounced member search using RxJS Subject
searchMember(event: any) {
  const value = event?.target?.value || '';
  if (value && value.trim().length > 0) {
    this.showPleaseText = true;
    this.isSearchBoxShow = true;
    this.searchTerm$.next(value);
    this.cdr.markForCheck();
  } else {
    this.isSearchBoxShow = false;
    this.searchMembers = [];
    this.showPleaseText = false;
    this.memberName = '';
    this.cdr.markForCheck();
  }
}



  // Call backend and handle all response shapes for member search
  private executeListing(value: string) {
    this.isSearchBoxShow = true;
    this.showPleaseText = true;
    this.EventService.searchMembers(value).subscribe({
      next: (response) => {
        this.showPleaseText = false;
        // Accept array, {memberTeamAssignment: [...]}, or fallback
        if (response && Array.isArray(response)) {
          this.searchMembers = response;
        } else if (response && Array.isArray(response.memberTeamAssignment)) {
          this.searchMembers = response.memberTeamAssignment;
        } else if (response && Array.isArray(response.result)) {
          this.searchMembers = response.result;
        } else {
          this.searchMembers = [];
        }
        // Hide box if nothing found
        if (!this.searchMembers.length) {
          this.isSearchBoxShow = false;
        }
        this.cdr.markForCheck();
      },
      error: () => {
        this.showPleaseText = false;
        this.searchMembers = [];
        this.isSearchBoxShow = false;
        this.cdr.markForCheck();
      }
    });
  }

// Set member details and close search box, enforce name always filled
selectedMember(data: any) {
  if (!data) return;
  this.isChangedEdit = true;
  // Normalize member identifiers across different API shapes (api/members vs older endpoints)
  const memberId = (data.memberId ?? data.id ?? data.MemberId ?? data.memberID ?? '').toString();
  this.member = {
    ...data,
    // keep both keys so downstream code paths remain stable
    memberId: data.memberId ?? data.id ?? data.MemberId ?? data.memberID,
    id: data.id ?? data.memberId ?? data.MemberId ?? data.memberID
  };
  // Always set the input to the correct full name
  if (data.firstName || data.lastName) {
    this.memberName = `${data.firstName ?? ''} ${data.lastName ?? ''}`.trim();
  } else if (data.fullName) {
    this.memberName = data.fullName.trim();
  } else if (data.name) {
    this.memberName = data.name.trim();
  } else {
    this.memberName = 'Member'; // fallback, never empty
  }
  // Log selection
  console.log('Selected member:', this.memberName, data);

  // Auto-fill Time Zone* from the clicked member (api/members search response)
  const tzFromSearch =
    data.timeZone ||
    data.timezone ||
    data.timeZoneId ||
    data.timeZoneName;
  if (tzFromSearch && typeof tzFromSearch === 'string' && tzFromSearch.trim().length > 0) {
    this.eventDetails.timeZone = tzFromSearch.trim();
    this.requiredFieldErrors.timeZone = false;
  }

  // Only now close dropdown and clear search list
  this.isSearchBoxShow = false;
  this.searchMembers = [];
  this.showPleaseText = false;
  this.meetings = [];
  if (memberId) {
    this.memberService.GetMeetings(memberId).subscribe((response: any) => {
      // Normalize different backend response shapes into an array
      this.meetings = Array.isArray(response)
        ? response
        : (Array.isArray(response?.result) ? response.result : []);
    });
    
    // Fallback: if timezone wasn't in search response, fetch member details and fill it
    if (!this.eventDetails.timeZone || this.eventDetails.timeZone === '0') {
      this.memberService.getMemberById(memberId).subscribe((response: any) => {
        const tz =
          response?.timeZone ||
          response?.timezone ||
          response?.result?.timeZone ||
          response?.result?.timezone;
        if (tz && typeof tz === 'string' && tz.trim().length > 0) {
          this.eventDetails.timeZone = tz.trim();
          this.requiredFieldErrors.timeZone = false;
          this.cdr.markForCheck();
        }
      });
    }
  }
  // Ensure eventAudienceMemberId is set when a member is selected
  this.eventDetails.eventAudienceMemberId = memberId || '';
  // update view after selection (OnPush)
  this.cdr.markForCheck();
}
}